import { Environment } from '../../config/environment';
import { IRibbon2Container, IWatchlistElementV1 } from '../models/AndromeTV.types';
import { Backend } from '../Backend';
import { WatchlistFilter, WatchlistID, WatchlistRibbonFilter } from './WatchlistApi.types';

export class WatchlistApi {
  /**
   * Retrieve the watchlist with the specified type and id
   */
  static watchlist(backend: Backend, watchlistId: WatchlistID): Promise<IWatchlistElementV1> {
    const type = encodeURIComponent(watchlistId.type);
    const id = encodeURIComponent(watchlistId.id);
    const url = backend.makeUrl(`history/v1/watchlist/${type}/${id}`, {
      profileId: watchlistId.profileId,
    });
    return backend.getJson(url, backend.bearer) as Promise<IWatchlistElementV1>;
  }

  /**
   * Create or update a watchlist item
   */
  static update(backend: Backend, watchlistId: WatchlistID) {
    const type = encodeURIComponent(watchlistId.type);
    const id = encodeURIComponent(watchlistId.id);
    const url = backend.makeUrl(`history/v1/watchlist/${type}/${id}`, {
      profileId: watchlistId.profileId,
    });
    return backend.putJson(url, {}, backend.bearer);
  }

  /**
   * Remove a watchlist
   */
  static delete(backend: Backend, watchlistId: WatchlistID) {
    const type = encodeURIComponent(watchlistId.type);
    const id = encodeURIComponent(watchlistId.id);
    const url = backend.makeUrl(`history/v1/watchlist/${type}/${id}`, {
      profileId: watchlistId.profileId,
    });
    return backend.delete(url, backend.bearer);
  }

  /**
   * Retrieve a list of watchlist items
   */
  static list(backend: Backend, filter: WatchlistFilter): Promise<IWatchlistElementV1[]> {
    const url = backend.makeUrl('history/v1/watchlist', filter);
    return backend.getJson(url, backend.bearer) as Promise<IWatchlistElementV1[]>;
  }

  /**
   * Retrieve a list of watchlist items in CMS Ribbon format
   */
  static ribbon(backend: Backend, filter: WatchlistRibbonFilter): Promise<IRibbon2Container> {
    const queryParam = {
      platform: Environment.system,
      ...filter,
    };
    const url = backend.makeUrl('history/v2/cms/watchlist', queryParam);
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container>;
  }
}
